import { defineComponent as _defineComponent } from 'vue'
import { defineComponent } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'kakao.icon',
  props: {
    height: null
  },
  setup(__props: any) {

const props = __props as {
  height?: string;
};

defineComponent({
  name: 'KakaoIcon',
});



const height = props.height || '24px';

return { __sfc: true,props, height }
}

})